// Thin top progress bar

export function renderProgressBar(progress: number): HTMLElement {
  const wrapper = document.createElement('div');
  wrapper.className = 'w-full';

  const track = document.createElement('div');
  track.className = 'bg-gray-200 h-2 rounded-full overflow-hidden';

  const bar = document.createElement('div');
  bar.className = 'bg-blue-600 h-2 rounded-full transition-all duration-300';
  bar.style.width = `${Math.max(0, Math.min(100, progress))}%`;

  track.appendChild(bar);
  wrapper.appendChild(track);
  return wrapper;
}
